// extracted by mini-css-extract-plugin
export default {"component":"TimeOffPage_component__dGzXQ","nav":"TimeOffPage_nav__f08vC"};